import { useMemo } from 'react';
import L from 'leaflet';
import { CustomAlert } from 'components/AlertsCollection';

export const addAlertDiv = (alert: CustomAlert) => () => {
  const div = L.DomUtil.create('div', 'map-alert');
  div.innerHTML = `<div class="ds-snackbar-container ds-snackbar-${alert.variant} p-3">
    <strong>[${alert.title}]</strong> ${alert.message}
  </div>`;
  return div;
};

export default function useAlertControl(alert: CustomAlert | undefined) {
  return useMemo(() => {
    if (!alert) return undefined;

    const alertControl = new L.Control();
    alertControl.onAdd = addAlertDiv(alert);

    return alertControl;
  }, [alert]);
}
